import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { format } from "date-fns";
import { pl } from "date-fns/locale"; // Importuj lokalizację polską
import DatePicker from "react-datepicker"; // Importuj DatePicker
import "react-datepicker/dist/react-datepicker.css"; // Importuj style
import backgroundImage from "../../assets/FOTO/IMG_8412.png"; // Dostosuj ścieżkę do swojego obrazu

const FirstVisit = () => {
  const trainingTypes = [
    "Konsultacja + trening personalny EMS + drenaż limfatyczny za 69 zł",
    "Konsultacja + trening personalny siłowy (bez kombinezonu EMS) za 69 zł",
    "Pierwsza wizyta Program Hybrydowy (EMS + siłowy) za 89zl",
  ];

  const mapTrainingTypeToTrainer = (type) => {
    switch (type) {
      case "Konsultacja + trening personalny EMS + drenaż limfatyczny za 69 zł":
        return "Solo Personalny";
      case "Konsultacja + trening personalny siłowy (bez kombinezonu EMS) za 69 zł":
        return "Solo Personalny";
      case "Pierwsza wizyta Program Hybrydowy (EMS + siłowy) za 89zl":
        return "Hybryda";
      default:
        return null;
    }
  };

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    trainingType: "",
    selectedDate: null, // Ustaw na null
    selectedTime: "",
  });
  const [availableHours, setAvailableHours] = useState([]);
  const [bookingSuccess, setBookingSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [selectedTrainer, setSelectedTrainer] = useState(null);
  const [trainersForSelectedTime, setTrainersForSelectedTime] = useState([]);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  // Poprawiona funkcja fetchAvailableHours
  const fetchAvailableHours = async (date, type, trainerId = null) => {
    try {
      const formattedDate =
        typeof date === "string" ? date : format(date, "yyyy-MM-dd");
      const response = await axios.get(
        `${BACKEND_URL}/api/treningi/getAvailableHours`,
        {
          params: {
            date: formattedDate,
            typTreningu: type,
            trener_id: trainerId,
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAvailableHours(response.data.availableHours || []);
    } catch (err) {
      setError("Błąd podczas pobierania dostępnych godzin");
    }
  };

  // Wywołuj fetchAvailableHours po każdej zmianie daty lub typu treningu (NIE selectedTrainer)
  useEffect(() => {
    if (formData.selectedDate && formData.trainingType) {
      fetchAvailableHours(
        formData.selectedDate,
        mapTrainingTypeToTrainer(formData.trainingType)
      );
      setFormData((prev) => ({ ...prev, selectedTime: "" }));
      setTrainersForSelectedTime([]);
      setSelectedTrainer(null);
    }
    // eslint-disable-next-line
  }, [formData.selectedDate, formData.trainingType]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Reset time when date or training type changes
    if (name === "selectedDate" || name === "trainingType") {
      setFormData((prev) => ({ ...prev, selectedTime: "" }));
    }
  };

  // handleTimeSelection bez fetchowania godzin (fetch wywoła się przez useEffect)
  const handleTimeSelection = (e) => {
    const time = e.target.value;
    setFormData((prev) => ({
      ...prev,
      selectedTime: time,
    }));
    const timeSlot = availableHours.find((h) => h.time === time);
    if (timeSlot && timeSlot.availableTrainers.length > 0) {
      setTrainersForSelectedTime(timeSlot.availableTrainers);
      setSelectedTrainer(timeSlot.availableTrainers[0]);
    } else {
      setTrainersForSelectedTime([]);
      setSelectedTrainer(null);
    }
  };

  const checkTrainingCollision = async (date, startTime, endTime) => {
    try {
      const formattedDate = format(date, "yyyy-MM-dd");

      const response = await axios.get(
        `${BACKEND_URL}/api/treningi/getTreningi`,
        {
          params: {
            date: formattedDate, // Pobieramy tylko treningi z danego dnia
          },
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Dodaj token do nagłówka
          },
        }
      );

      const sameDayEvents = response.data.filter(
        (event) =>
          format(new Date(event.godzina_start), "yyyy-MM-dd") === formattedDate
      );

      const overlappingEvents = sameDayEvents.filter(
        (event) =>
          new Date(startTime) < new Date(event.godzina_koniec) &&
          new Date(endTime) > new Date(event.godzina_start)
      );

      return overlappingEvents.length > 0; // Jeśli istnieją kolidujące wydarzenia, zwracamy true
    } catch (error) {
      console.error("Error checking training collision:", error);
      return false; // W przypadku błędu zwracamy false, aby nie blokować godzin
    }
  };

  const formatToWarsawTime = (utcTime) => {
    const date = new Date(utcTime);
    return date.toLocaleString("pl-PL", {
      timeZone: "Europe/Warsaw",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!selectedTrainer) {
      setError("Nie wybrano trenera lub brak dostępnych trenerów");
      return;
    }

    try {
      const startDateTime = `${
        formData.selectedDate.toISOString().split("T")[0]
      }T${formData.selectedTime}`;
      const duration = 60; // Domyślny czas 60 minut
      const endDateTime = new Date(
        new Date(startDateTime).getTime() + duration * 60 * 1000
      ).toISOString();

      // Sprawdź kolizję treningów
      const hasCollision = await checkTrainingCollision(
        formData.selectedDate,
        startDateTime,
        endDateTime
      );
      if (hasCollision) {
        setError("Wybrany slot czasowy jest już zajęty. Wybierz inną godzinę.");
        return;
      }

      const adjustedDate = new Date(formData.selectedDate);
      adjustedDate.setDate(adjustedDate.getDate() + 1);

      const requestData = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        trainingType: formData.trainingType,
        selectedDate: adjustedDate.toISOString().split("T")[0],
        selectedTime: formData.selectedTime,
        trainerId: selectedTrainer._id,
      };

      const response = await axios.post(
        `${BACKEND_URL}/api/treningi/addFirstVisit`,
        requestData
      );

      setBookingSuccess(true);
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        trainingType: "",
        selectedDate: null,
        selectedTime: "",
      });
      setAvailableHours([]);
      setSelectedTrainer(null);
      setTrainersForSelectedTime([]);
    } catch (err) {
      console.error("Full error details:", err.response?.data);
      setError(
        err.response?.data?.message ||
          "Błąd podczas rezerwacji. Spróbuj ponownie później."
      );
    }
  };

  return (
    <section className="bg-[#191919] text-white pb-10">
      {/* Hero Section z tłem */}
      <div
        className="relative bg-cover bg-center pt-[150px] pb-[50px]"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
          <motion.h1
            className="text-5xl font-semibold mb-6 text-white uppercase"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Pierwsza Wizyta
          </motion.h1>
          <motion.p
            className="text-xl text-[#F5EBDC] mb-8 leading-relaxed"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            Rozpocznij swoją przygodę z profesjonalnym treningiem! Pierwsza
            wizyta to idealna okazja, aby poznać nasze podejście do treningu,
            przedyskutować Twoje cele i stworzyć plan działania. Nasi
            doświadczeni trenerzy pomogą Ci rozpocząć transformację w najlepszej
            możliwej formie.
          </motion.p>
        </div>
      </div>

      {/* Form Section */}
      <motion.div
        className="max-w-4xl mx-auto mt-[-50px] px-4 relative z-20"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.5 }}
      >
        <div className="bg-[#242424] rounded-lg shadow-xl p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {bookingSuccess && (
              <div className="mb-4 p-3 bg-green-100 text-green-700 rounded-md">
                Dziękujemy za rezerwację! Skontaktujemy się z Tobą wkrótce.
              </div>
            )}

            {/* Personal Details */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                  Imię *
                </label>
                <input
                  type="text"
                  name="firstName"
                  required
                  className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                  value={formData.firstName}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                  Nazwisko *
                </label>
                <input
                  type="text"
                  name="lastName"
                  required
                  className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                  value={formData.lastName}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                  Telefon *
                </label>
                <input
                  type="tel"
                  name="phone"
                  required
                  className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            {/* Training Details */}
            <div>
              <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                Rodzaj Treningu *
              </label>
              <select
                name="trainingType"
                required
                className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                value={formData.trainingType}
                onChange={handleInputChange}
              >
                <option value="">Wybierz rodzaj treningu</option>
                {trainingTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                  Data *
                </label>
                <DatePicker
                  selected={formData.selectedDate}
                  onChange={(date) => {
                    setFormData((prev) => ({
                      ...prev,
                      selectedDate: date,
                    }));
                    // fetchAvailableHours wywoła się automatycznie przez useEffect
                  }}
                  minDate={new Date()} // Ustaw minimalną datę na dzisiaj
                  filterDate={(date) => date.getDay() !== 0} // Blokuj weekendy
                  className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                  placeholderText="Wybierz datę"
                  locale={pl} // Ustaw lokalizację na polski
                />
              </div>
              <div>
                <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                  Godzina *
                </label>
                <select
                  name="selectedTime"
                  required
                  className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                  value={formData.selectedTime}
                  onChange={handleTimeSelection}
                  disabled={!formData.selectedDate || !formData.trainingType}
                >
                  <option value="">Wybierz godzinę</option>
                  {availableHours.map(({ time, availableTrainers }) => (
                    <option
                      key={time}
                      value={time}
                      disabled={availableTrainers.length === 0}
                    >
                      {time}{" "}
                      {availableTrainers.length === 0 ? "(brak miejsc)" : ""}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {formData.selectedTime && trainersForSelectedTime.length > 1 && (
              <div className="mb-6">
                <label className="block text-[#F5EBDC] text-sm font-bold mb-2">
                  Wybierz Trenera *
                </label>
                <select
                  className="w-full p-3 bg-[#333] border border-[#444] rounded-lg text-white"
                  value={selectedTrainer?._id || ""}
                  onChange={(e) => {
                    const trainer = trainersForSelectedTime.find(
                      (t) => t._id === e.target.value
                    );
                    setSelectedTrainer(trainer || null);
                  }}
                >
                  {trainersForSelectedTime.map((trainer) => (
                    <option key={trainer._id} value={trainer._id}>
                      {trainer.imie} {trainer.nazwisko}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {formData.trainingType &&
              formData.selectedDate &&
              formData.selectedTime &&
              selectedTrainer && (
                <div className="mb-6 p-4 bg-blue-50 rounded-lg text-black">
                  <h3 className="font-bold text-blue-800 mb-2">
                    Podsumowanie Rezerwacji
                  </h3>
                  <p className="text-sm text-blue-600">
                    Rodzaj Treningu:{" "}
                    {mapTrainingTypeToTrainer(formData.trainingType)}
                    <br />
                    Data:{" "}
                    {format(formData.selectedDate, "d MMMM yyyy", {
                      locale: pl,
                    })}
                    <br />
                    Godzina: {formData.selectedTime}
                    <br />
                  </p>
                </div>
              )}

            <button
              type="submit"
              className="w-full p-4 bg-[#F5EBDC] text-[#191919] rounded-lg font-bold hover:bg-[#e5dbd0] transition-colors"
            >
              Zarezerwuj Pierwszą Wizytę
            </button>
          </form>
        </div>
      </motion.div>

      {/* Dodatkowe informacje */}
      <motion.div
        className="max-w-4xl mx-auto mt-12 px-4 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.8 }}
      >
        <p className="text-[#F5EBDC] text-sm">
          * Pierwsza wizyta trwa 60 minut i zawiera konsultację z trenerem oraz
          wstępny trening
        </p>
      </motion.div>
    </section>
  );
};

export default FirstVisit;
